export default __webpack_public_path__ + "static/engagement_models-bf872b7ccbb1d739d6ebaaeaf0d0954d.webp";